// extracted by mini-css-extract-plugin
export default {"container":"brands_container__4sy4z","brands":"brands_brands__Oy1C2","train":"brands_train__ZRID9"};